import axios from 'axios';

const pendingData = {};
const getLocalData = () => {
    try {
        return JSON.parse(window.localStorage.getItem('cfd-specification')) || {};
    } catch (ex) {
        console.error('getLocalData error', ex);
        window.localStorage.removeItem('cfd-specification');
        return {};
    }
};
const setLocalData = ({ data }) => {
    try {
        window.localStorage.setItem('cfd-specification', JSON.stringify(data));
    } catch (ex) {
        console.error('setLocalData error', ex);
    }
};
const getLocalItem = ({ url }) => {
    const data = getLocalData();
    return data[url];
};
const setLocalItem = ({ url, item }) => {
    const data = getLocalData();
    data[url] = item;
    setLocalData({ data });
};
const removeLocalItem = ({ url }) => {
    const data = getLocalData();
    delete data[url];
    setLocalData({ data });
};

const getData = ({ url, cacheTtl }) => {
    const now = Date.now();
    const pendingItem = pendingData[url];
    if (pendingItem) {
        if (pendingItem.timestamp > now - cacheTtl) {
            return pendingItem.promise;
        } else {
            delete pendingData[url];
        }
    }

    const localItem = getLocalItem({ url });
    if (localItem) {
        if (localItem.timestamp > now - cacheTtl) {
            const promise = Promise.resolve(localItem.data);
            pendingData[url] = {
                promise,
                timestamp: localItem.timestamp
            };
            return promise;
        } else {
            removeLocalItem({ url });
        }
    }

    const promise = axios.get(url)
        .then(({ data }) => {
            setLocalItem({
                url,
                item: {
                    data,
                    timestamp: now
                }
            });
            return data;
        })
        .catch(ex => {
            delete pendingData[url];
            console.error('getData error', ex);
        });

    pendingData[url] = {
        promise,
        timestamp: now
    };
    return promise;
};

export default {
    getPlatforms ({ source, lang, broker, cacheTtl }) {
        const url = `${source}/constructor/short_configuration/${broker}/${lang}`;
        return getData({ url, cacheTtl }).then(res => res.Platforms);
    },
    getInstruments ({ source, platformCode, lang, broker, currency, cacheTtl }) {
        const url = `${source}/data/instruments/${broker}/${lang}/${platformCode}/${currency}`;
        return getData({ url, cacheTtl }).then(res => res.Instruments);
    },
    getColumns ({ source, lang, currency, dataGridId, cacheTtl }) {
        const url = `${source}/constructor/data_grid_configuration/${lang}/${currency}/${dataGridId}`;
        return getData({ url, cacheTtl }).then(res => res.Columns);
    }
};



// WEBPACK FOOTER //
// ./src/api/index.js